import React, { useEffect, useState } from 'react';
import { graphql } from 'gatsby';
//@ts-ignore
import * as styles from './product-tour.module.css';
//@ts-ignore
import {
    KontentStringValue,
    KontentMedia,
    CTALocation,
    KontentProductImage,
    KontentRadioMultiChoice,
} from '../../../types/KontentProps';
import CtaLink from '../Global/CtaLink';
import { getMediaData, getMultiChoice } from '../Global/DataUtils';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import { loadEpigraphAR } from '../../utils/epigraphLoader';
import SharedEpigraphViewer from '../../global/sharedEpigraphViewer';
interface Props {
    cta_configuration__cta_label?: KontentStringValue;
    cta_configuration__cta_location?: CTALocation;
    cta_configuration__cta_window_action?: {
        value: {
            codename: 'same_window' | 'new_window';
        }[];
    };
    show_hide_cta?: KontentRadioMultiChoice<'show' | 'hide'>;
    cta_configuration__cta_location_anchor_point: {
        value: string;
    };
    cta_copy: KontentStringValue;
    cta_icons: KontentProductImage;
    sku: KontentStringValue;
    ua_code: KontentStringValue;
    ga_measurement_id: KontentStringValue;
    product_tour_sku: KontentStringValue;
    foreground_image: KontentMedia;
    component_anchor_name: KontentStringValue;
    kontentItemId?: string;
}

const ProductTour: React.FC<Props> = ({
    cta_configuration__cta_label,
    cta_configuration__cta_location,
    cta_configuration__cta_window_action,
    cta_copy,
    cta_icons,
    sku,
    ua_code,
    cta_configuration__cta_location_anchor_point,
    ga_measurement_id,
    product_tour_sku,
    foreground_image,
    component_anchor_name,
    show_hide_cta,
    kontentItemId,
}) => {
    const [epigraphReady, setEpigraphReady] = useState(false);
    const [epigraphError, setEpigraphError] = useState(false);
    const anchor_name = component_anchor_name?.value;

    useEffect(() => {
        if (product_tour_sku?.value) {
            loadEpigraphAR()
                .then(() => {
                    setEpigraphReady(true);
                })
                .catch((err) => {
                    console.warn('Failed to load Epigraph AR:', err);
                    setEpigraphError(true);
                });
        }
    }, [product_tour_sku]);
    const ctaCopy = cta_copy?.value;
    const epigraphCtaBoxIcon =
        cta_icons?.value[0]?.elements?.file?.value[0]?.url;
    const epigraphCtaBoxHoverIcon =
        cta_icons?.value[1]?.elements?.file?.value[0]?.url;
    const ctaAnchorValue = cta_configuration__cta_location_anchor_point?.value;
    const getPricingCtaTarget =
        getMultiChoice(cta_configuration__cta_window_action) === 'new_window'
            ? '_blank'
            : '_self';

    const showGetPricing =
        getMultiChoice(show_hide_cta) === 'show' ? true : false;
    const epigraphCtaSku = sku?.value;
    const epigraphUaCode = ua_code?.value;
    const foreGroundImage = getMediaData(foreground_image);

    return (
        <section
            id={anchor_name || undefined}
            data-kontent-item-id={kontentItemId}
        >
            <div className={styles.productTourContainer}>
                <div className={styles.productTour}>
                    <SharedEpigraphViewer
                        epigraphReady={epigraphReady}
                        error={epigraphError}
                        sku={product_tour_sku?.value}
                        uaCode={epigraphUaCode}
                        gaMeasurementId={ga_measurement_id?.value}
                        foregroundImageUrl={foreGroundImage?.url}
                        mobileContainerClassName={
                            styles.mobileProductTourContainer
                        }
                        pictureClassName={styles.picture}
                    />
                </div>
                <div className={styles.links}>
                    {showGetPricing && (
                        <div className={styles.getpricingcta}>
                            <CtaLink
                                href={
                                    cta_configuration__cta_location_anchor_point?.value
                                        ? BuildLinkHref(
                                              cta_configuration__cta_location
                                          ) +
                                          '#' +
                                          cta_configuration__cta_location_anchor_point?.value
                                        : BuildLinkHref(
                                              cta_configuration__cta_location
                                          )
                                }
                                target={getPricingCtaTarget}
                            >
                                {cta_configuration__cta_label.value}
                            </CtaLink>
                        </div>
                    )}
                    {epigraphReady && (
                        <div className={styles.viewSauna}>
                            <epigraph-ar
                                sku={epigraphCtaSku}
                                ua-code={epigraphUaCode}
                                ga-measurement-id={ga_measurement_id?.value}
                            >
                                <button
                                    slot="ar-button"
                                    className={styles.epigraphBtn}
                                >
                                    <span className={styles.boxIcons}>
                                        <img src={epigraphCtaBoxIcon} alt="" />
                                        <img
                                            src={epigraphCtaBoxHoverIcon}
                                            alt=""
                                        />
                                    </span>
                                    <span data-kontent-element-codename="cta_copy">
                                        {ctaCopy}
                                    </span>
                                </button>
                            </epigraph-ar>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ProductTour;

export const fragmentProductTour = graphql`
    fragment ProductTour on kontent_item_component___product_tour {
        elements {
            component_anchor_name {
                value
            }
            cta_configuration__cta_label {
                value
            }
            cta_configuration__cta_location {
                ...kontentCtaLocation
            }
            cta_configuration__cta_location_anchor_point {
                value
            }
            cta_configuration__cta_window_action {
                value {
                    codename
                }
            }
            cta_copy {
                value
            }
            cta_icons {
                value {
                    ... on kontent_item_media___image {
                        elements {
                            file {
                                value {
                                    url
                                }
                            }
                        }
                    }
                }
            }
            sku {
                value
            }
            ua_code {
                value
            }
            product_tour_sku {
                value
            }
            ga_measurement_id {
                value
            }
            foreground_image {
                ...kontentImage
            }
            show_hide_cta {
                value {
                    codename
                }
            }
        }
    }
`;
